import { render, staticRenderFns } from "./PosProductModal.template.vue?vue&type=template&id=618e0dfc&scoped=true&"
var script = {}
import style0 from "./PosProductModal.template.vue?vue&type=style&index=0&id=618e0dfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e0dfc",
  null
  
)

export default component.exports